import { useState } from "react";
import { Button, DropdownMenu, Icon, Modal, Typography } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useRemovePreferredDriverMutation } from "@/redux/apis/clientDispatch/clientDispatchApi";
import { PreferredDriver } from "@/redux/apis/clientDispatch/types";
import { addToast } from "@/utils";

interface RemovePreferredDriverActionProps {
  driver: PreferredDriver;
  accountId?: string;
}

export const RemovePreferredDriverAction = ({ driver, accountId }: RemovePreferredDriverActionProps) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [removePreferredDriver, { isLoading }] = useRemovePreferredDriverMutation();

  const handleRemove = () => {
    removePreferredDriver({ preferredAccountUuid: driver.accountUuid, accountId })
      .unwrap()
      .then(() => {
        addToast("success", `${driver.driverName} has been removed from your favourite list.`);
        setIsConfirmOpen(false);
      })
      .catch((error) => addToast("danger", getErrorMessages(error)[0]));
  };

  return (
    <>
      <DropdownMenu
        button={
          <DropdownMenu.Button aria-label="Driver actions" className="inline-flex items-center justify-center text-neutral-black">
            <Icon name="options" isCustom size="lg" />
          </DropdownMenu.Button>
        }
        isCustomButton
        position="bottom-end"
      >
        <DropdownMenu.Item onClick={() => setIsConfirmOpen(true)} className="w-56">
          <Icon name="Trash" size="sm" className="mr-2.5 flex-shrink-0 text-danger" />
          <Typography className="text-danger">Remove Driver</Typography>
        </DropdownMenu.Item>
      </DropdownMenu>

      <Modal
        open={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        variant="web-small"
        title="Remove Driver"
        renderButtons={() => (
          <>
            <Button variant="tertiary" size="md" onClick={() => setIsConfirmOpen(false)} disabled={isLoading}>
              Cancel
            </Button>
            <Button
              variant="primary"
              size="md"
              className="border-danger bg-danger hover:bg-danger-dark"
              onClick={handleRemove}
              disabled={isLoading}
            >
              Remove
            </Button>
          </>
        )}
      >
        <Typography className="text-neutral-dark-gray">
          Are you sure you want to remove <span className="text-info">{driver.driverName}</span> from your favourite list?
        </Typography>
      </Modal>
    </>
  );
};
